module.exports = __webpack_public_path__ + "img/ball2_dn.1533d492.png";